import React, { useState, useEffect } from "react";
import Select from "react-select";

import { getDeliver } from "../../../service/api/Deliver/apiDeliver";

const SearchArea = ({
    searchForm,
    setSearchForm,
    onSearch,
    onReset,
    loading
}) => {
    const [drivers, setDrivers] = useState([]);

    useEffect(() => {
        // 從 API 獲取司機列表
        const fetchDrivers = async () => {
            try {
                const response = await getDeliver();
                if (response.status === 200 && response.data.status === 1) {
                    const driversList = response.data.result || [];
                    setDrivers(driversList);
                }
            } catch (error) {
                console.error('獲取司機列表失敗:', error);
            }
        };
        
        fetchDrivers();
    }, []);
    return (
        <div className="card-body">
            {/* 頂部區段：第一行 - 訂單編號、姓名、電話 */}
            <div className="search-section">
                <div className="row g-4">
                    <div className="col-lg-4 col-md-6">
                        <div className="form-group-premium">
                            <input
                                id="orderId"
                                name="orderId"
                                type="text"
                                className="form-control-premium"
                                value={searchForm.id}
                                onChange={(e) => setSearchForm(prev => ({ ...prev, id: e.target.value }))}
                                placeholder="訂單編號"
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="form-group-premium">
                            <input
                                id="customerName"
                                name="customerName"
                                type="text"
                                className="form-control-premium"
                                value={searchForm.name}
                                onChange={(e) => setSearchForm(prev => ({ ...prev, name: e.target.value }))}
                                placeholder="姓名"
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="form-group-premium">
                            <input
                                id="phone"
                                name="phone"
                                type="text"
                                className="form-control-premium"
                                value={searchForm.phone}
                                onChange={(e) => setSearchForm(prev => ({ ...prev, phone: e.target.value }))}
                                placeholder="電話"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* 第二行 - Email、司機、縣市 */}
            <div className="search-section">
                <div className="row g-4">
                    <div className="col-lg-4 col-md-6">
                        <div className="form-group-premium">
                            <input
                                id="email"
                                name="email"
                                type="text"
                                className="form-control-premium"
                                value={searchForm.email}
                                onChange={(e) => setSearchForm(prev => ({ ...prev, email: e.target.value }))}
                                placeholder="Email"
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="form-group-premium">
                            <Select
                                inputId="deliverName"
                                name="deliverName"
                                options={drivers.map(driver => ({ value: driver.name, label: driver.name }))}
                                value={searchForm.deliverName ? { value: searchForm.deliverName, label: searchForm.deliverName } : null}
                                onChange={(option) => setSearchForm(prev => ({ ...prev, deliverName: option?.value || '' }))}
                                isClearable
                                isSearchable
                                placeholder="-- 選擇司機 --"
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        borderColor: '#dadce0',
                                        borderRadius: '8px',
                                        padding: '2px 8px',
                                        minHeight: '40px',
                                        fontSize: '14px'
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#1f73e6' : state.isFocused ? '#f0f2f5' : 'white',
                                        color: state.isSelected ? 'white' : '#202124'
                                    })
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="form-group-premium">
                            <input
                                id="addressCity"
                                name="addressCity"
                                type="text"
                                className="form-control-premium"
                                value={searchForm.addressCity}
                                onChange={(e) => setSearchForm(prev => ({ ...prev, addressCity: e.target.value }))}
                                placeholder="縣市"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* 第三行：日期範圍 + 狀態篩選 */}
            <div className="search-section">
                <div className="row g-4">
                    {/* 日期範圍 */}
                    <div className="col-lg-4">
                        <div className="date-range-group">
                            <div className="d-flex gap-2 align-items-center">
                                <div className="flex-grow-1">
                                    <input
                                        id="deliveryDateStart"
                                        name="deliveryDateStart"
                                        type="date"
                                        className="form-control-premium"
                                        value={searchForm.deliveryDateStart}
                                        onChange={(e) => setSearchForm(prev => ({ ...prev, deliveryDateStart: e.target.value }))}
                                        placeholder="起始日期"
                                    />
                                </div>
                                <span className="text-muted" style={{ fontSize: '0.9rem', whiteSpace: 'nowrap' }}>～</span>
                                <div className="flex-grow-1">
                                    <input
                                        id="deliveryDateEnd"
                                        name="deliveryDateEnd"
                                        type="date"
                                        className="form-control-premium"
                                        value={searchForm.deliveryDateEnd}
                                        onChange={(e) => setSearchForm(prev => ({ ...prev, deliveryDateEnd: e.target.value }))}
                                        placeholder="結束日期"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 寄送狀態 */}
                    <div className="col-lg-4">
                        <div style={{ paddingTop: '6px' }}>
                            <div className="status-toggle-group">
                                <button className={`status-btn ${searchForm.isShipped === '' ? 'active' : ''}`} onClick={() => setSearchForm(prev => ({ ...prev, isShipped: '' }))} title="全部">全部</button>
                                <button className={`status-btn ${searchForm.isShipped === 1 ? 'active' : ''}`} onClick={() => setSearchForm(prev => ({ ...prev, isShipped: 1 }))} title="已送達">✓ 已送達</button>
                                <button className={`status-btn ${searchForm.isShipped === 0 ? 'active' : ''}`} onClick={() => setSearchForm(prev => ({ ...prev, isShipped: 0 }))} title="未送達">✗ 未送達</button>
                            </div>
                        </div>
                    </div>

                    {/* 審核狀態 */}
                    <div className="col-lg-4">
                        <div style={{ paddingTop: '6px' }}>
                            <div className="status-toggle-group">
                                <button className={`status-btn ${searchForm.status === '' ? 'active' : ''}`} onClick={() => setSearchForm(prev => ({ ...prev, status: '' }))} title="全部">全部</button>
                                <button className={`status-btn ${searchForm.status === 1 ? 'active' : ''}`} onClick={() => setSearchForm(prev => ({ ...prev, status: 1 }))} title="已通過">✓ 通過</button>
                                <button className={`status-btn ${searchForm.status === 0 ? 'active' : ''}`} onClick={() => setSearchForm(prev => ({ ...prev, status: 0 }))} title="未審核">? 審核中</button>
                                <button className={`status-btn ${searchForm.status === 2 ? 'active' : ''}`} onClick={() => setSearchForm(prev => ({ ...prev, status: 2 }))} title="未通過">✗ 不通過</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* 動作按鈕 - 搜尋 & 重置 */}
            <div className="search-action-group">
                <button
                    className="btn btn-primary fw-bold"
                    onClick={onSearch}
                    disabled={loading}
                >
                    <i className="fas fa-search me-2"></i>{loading ? '搜尋中...' : '搜尋'}
                </button>
                <button
                    className="btn btn-secondary fw-bold"
                    onClick={onReset}
                >
                    <i className="fas fa-redo me-2"></i>重置
                </button>
            </div>
        </div>
    );
};

export { SearchArea };
